export default (wait) => {
    return new Promise((resolve) => {
        setTimeout(resolve, wait)
    })
}



// WEBPACK FOOTER //
// ./helpers/delay.js